import { Dispatch, SetStateAction } from "react";
import { useIntl } from "react-intl";
import { Input, Radio, Select } from "semantic-ui-react";
import { TranslateProps } from "../../../i18n/TranslateProps";
import {
    ICertificate,
    localScopeOptions,
    certificateNotesOptions,
    passengersOptions,
} from "../../../models/certificate";

type Props = {
    certificate: ICertificate;
    setCertificate: Dispatch<SetStateAction<ICertificate>>;
};

export const BoatmasterATInputs = ({ certificate, setCertificate }: Props) => {
    const intl = useIntl();

    return (
        <>
            <div className="certificate-row four">
                <section className="input-container">
                    <label>{intl.formatMessage({ id: "localScope" })}</label>
                    <Select
                        search
                        options={TranslateProps(localScopeOptions)}
                        value={certificate.localScope}
                        onChange={(e, data: any) => {
                            setCertificate({ ...certificate, localScope: +data.value });
                        }}
                    />
                </section>
                <section className="input-container">
                    <label>{intl.formatMessage({ id: "localScopeValue" })}</label>
                    <Input
                        value={certificate.localScopeValue ?? ""}
                        onChange={(e: any) =>
                            setCertificate({
                                ...certificate,
                                localScopeValue: e.target.value,
                            })
                        }
                    />
                </section>
                <section className="input-container">
                    <label>{intl.formatMessage({ id: "notes" })}</label>
                    <Select
                        closeOnBlur={false}
                        multiple
                        options={TranslateProps(certificateNotesOptions)}
                        value={certificate.certificateNotes}
                        onChange={(e, data: any) => {
                            setCertificate({ ...certificate, certificateNotes: data.value });
                        }}
                    />
                </section>
                <section className="input-container">
                    <label>{intl.formatMessage({ id: "notesValue" })}</label>
                    <Input
                        value={certificate.notesValue ?? ""}
                        onChange={(e: any) =>
                            setCertificate({
                                ...certificate,
                                notesValue: e.target.value,
                            })
                        }
                    />
                </section>
            </div>
            <div className="certificate-row four">
                <section className="input-container">
                    <label>
                        {intl.formatMessage({ id: "vehicleType" })}
                        <span className="input-required">*</span>
                    </label>
                    <Input
                        value={certificate.vehicleType ?? ""}
                        onChange={(e: any) =>
                            setCertificate({
                                ...certificate,
                                vehicleType: e.target.value,
                            })
                        }
                        maxLength={40}
                    />
                </section>
                <section className="input-container">
                    <label>{intl.formatMessage({ id: "passengers" })}</label>
                    <Select
                        search
                        options={TranslateProps(passengersOptions)}
                        value={certificate.passengers}
                        onChange={(e, data: any) =>
                            setCertificate({ ...certificate, passengers: +data.value })
                        }
                    />
                </section>
                <div id="certificate-row-span-two-last" className="certificate-row four">
                    <section className="input-container">
                        <label>{intl.formatMessage({ id: "radar" })}</label>
                        <Radio
                            toggle
                            onChange={() =>
                                setCertificate({ ...certificate, radar: !certificate.radar })
                            }
                            checked={certificate.radar}
                        />
                    </section>
                    <section className="input-container">
                        <label>{intl.formatMessage({ id: "vehicleLength" })} &lt; 20 m</label>
                        <Radio
                            toggle
                            onChange={() =>
                                setCertificate({
                                    ...certificate,
                                    vehicleLengthBoatmaster: !certificate.vehicleLengthBoatmaster,
                                })
                            }
                            checked={certificate.vehicleLengthBoatmaster}
                        />
                    </section>
                    <section id="certificate-row-span-two-last" className="input-container">
                        <label>{intl.formatMessage({ id: "materialScope" })}</label>
                        <Input
                            value={certificate.materialScope ?? ""}
                            onChange={(e: any) =>
                                setCertificate({
                                    ...certificate,
                                    materialScope: e.target.value,
                                })
                            }
                        />
                    </section>
                </div>
            </div>
        </>
    );
};
